export default {"src":"/_next/static/media/SportsInjuries.54838dbf.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};